import React, { useState } from 'react';
import { valoresDeDimension } from '../utils/agrupar';
import { ORIGENES } from '../utils/origenCatalogo';

// Panel para la dueña: copia el enlace del catálogo (completo, por categoría
// o por tipo) con un solo toque, listo para pegar en la bio o Story de Instagram.
export default function CompartirCatalogoModal({ negocioId, slug = null, categorias = [], productos = [], onCerrar }) {
  const [copiado, setCopiado] = useState(null); // clave del enlace recién copiado
  const [origen, setOrigen] = useState(null); // etiqueta ?o= para saber de dónde vienen los pedidos (sql/104)

  // Links de compartir: pasan por /c (tarjeta de vista previa) y redirigen al
  // catálogo. Con nombre corto: /c/lolitas · Sin él (compatibilidad): /c?n=<id>
  const raiz = slug ? `${window.location.origin}/c/${slug}` : `${window.location.origin}/c?n=${negocioId}`;
  const con = (qs) => {
    const partes = [qs, origen ? `o=${origen}` : ''].filter(Boolean).join('&');
    return partes ? `${raiz}${slug ? '?' : '&'}${partes}` : raiz;
  };
  const linkGeneral = con('');

  const copiar = async (clave, url) => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      // Respaldo para navegadores viejos / permisos.
      const ta = document.createElement('textarea');
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    setCopiado(clave);
    setTimeout(() => setCopiado((c) => (c === clave ? null : c)), 2000);
  };

  // Abre el catálogo en una pestaña nueva para verlo antes de enviarlo.
  const verPrevia = (url) => window.open(url, '_blank', 'noopener');

  const Fila = ({ clave, icono, titulo, url }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 0', borderBottom: '1px solid #ECE8F6' }}>
      <span style={{ fontSize: '17px', width: '34px', height: '34px', flexShrink: 0, display: 'grid', placeItems: 'center', background: '#F3E8FF', borderRadius: '9px' }}>{icono}</span>
      <span style={{ flex: 1, fontSize: '14px', fontWeight: 600, color: '#1C1830', minWidth: 0 }}>{titulo}</span>
      <button onClick={() => verPrevia(url)} title="Ver el catálogo antes de enviarlo"
        style={{ padding: '7px 12px', borderRadius: '999px', border: '1px solid var(--color-primario,#DB2777)', cursor: 'pointer', fontSize: '13px', fontWeight: 700,
          backgroundColor: 'white', color: 'var(--color-primario,#DB2777)', flexShrink: 0 }}>
        👁️ Ver
      </button>
      <button onClick={() => copiar(clave, url)}
        style={{ padding: '7px 12px', borderRadius: '999px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 700,
          backgroundColor: copiado === clave ? 'var(--k-verde)' : 'var(--color-primario,#DB2777)', color: 'white', minWidth: '88px', flexShrink: 0 }}>
        {copiado === clave ? '✓ Copiado' : '🔗 Copiar'}
      </button>
    </div>
  );

  return (
    <div onClick={onCerrar}
      style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 1000 }}>
      <div onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: 'white', borderRadius: '16px', maxWidth: '440px', width: '100%', maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
        <div style={{ backgroundColor: 'var(--color-primario,#DB2777)', color: 'white', padding: '16px 20px', borderRadius: '16px 16px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '17px' }}>🔗 Compartir catálogo</h3>
          <button onClick={onCerrar} style={{ background: 'none', border: 'none', color: 'white', fontSize: '22px', cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>

        <div style={{ padding: '16px 20px 20px' }}>
          <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#6B7280', lineHeight: 1.5 }}>
            Toca <b>👁️ Ver</b> para revisar el catálogo antes de enviarlo, y <b>🔗 Copiar</b> para pegar el enlace en tu <b>bio de Instagram</b> o el <b>sticker de "Enlace"</b> de una Story. 💕
          </p>

          {/* Etiqueta de origen: cada enlace dice dónde se compartió y el pedido lo guarda. */}
          <p style={{ margin: '0 0 6px', fontSize: '12px', fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            ¿Dónde lo vas a compartir?
          </p>
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '6px' }}>
            {[{ clave: null, etiqueta: 'Sin etiqueta', icono: '' }, ...ORIGENES].map((o) => (
              <button key={o.clave || 'ninguno'} onClick={() => setOrigen(o.clave)}
                style={{ padding: '6px 11px', borderRadius: '999px', fontSize: '12.5px', fontWeight: 700, cursor: 'pointer',
                  border: `1px solid ${origen === o.clave ? 'var(--color-primario,#DB2777)' : '#E5E7EB'}`,
                  backgroundColor: origen === o.clave ? 'var(--color-primario,#DB2777)' : 'white', color: origen === o.clave ? 'white' : '#374151' }}>
                {o.icono} {o.etiqueta}
              </button>
            ))}
          </div>
          <p style={{ margin: '0 0 10px', fontSize: '12px', color: '#6B7280', lineHeight: 1.45 }}>
            {origen
              ? <>Los enlaces de abajo llevan la etiqueta <b>{ORIGENES.find((o) => o.clave === origen)?.etiqueta}</b>: en <b>Pedidos</b> verás de dónde llegó cada pedido.</>
              : 'Elige dónde lo vas a compartir para saber después de dónde vienen tus pedidos.'}
          </p>

          <Fila clave="general" icono="🛍️" titulo="Todo el catálogo" url={linkGeneral} />

          <p style={{ margin: '14px 0 4px', fontSize: '12px', fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Por categoría
          </p>
          {categorias.map((c) => {
            const tipos = valoresDeDimension(
              productos.filter((p) => p.categoria === c.nombre), 'subtipo'
            ).valores;
            return (
              <div key={c.prefijo}>
                <Fila clave={c.prefijo} icono={c.icono} titulo={c.nombre}
                  url={con(`cats=${c.prefijo}`)} />
                {tipos.map((t) => (
                  <div key={t} style={{ paddingLeft: '30px' }}>
                    <Fila clave={`${c.prefijo}:${t}`} icono="›" titulo={`Solo ${t}`}
                      url={con(`cats=${c.prefijo}&tipo=${encodeURIComponent(t)}`)} />
                  </div>
                ))}
              </div>
            );
          })}

          <p style={{ margin: '16px 0 0', fontSize: '12px', color: '#9CA3AF', lineHeight: 1.5 }}>
            💡 Para un <b>producto específico</b>, usa el botón <b>"Compartir"</b> que aparece en cada producto del catálogo.
          </p>

          <p style={{ margin: '18px 0 4px', fontSize: '12px', fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Para anuncios en Facebook e Instagram
          </p>
          <Fila clave="feed-meta" icono="📦" titulo="Catálogo para Meta (feed)"
            url={slug ? `${window.location.origin}/feed/${slug}` : `${window.location.origin}/api/feed?n=${negocioId}`} />
          <p style={{ margin: '8px 0 0', fontSize: '12px', color: '#9CA3AF', lineHeight: 1.5 }}>
            Pega este enlace en el <b>Administrador de ventas de Meta</b> (Catálogo → Fuentes de datos → Feed de datos programado). Meta lee tus productos solo y se actualiza cuando cambias precios o stock en Kontrol.
          </p>
        </div>
      </div>
    </div>
  );
}
